import footerNavStyle from 'modules/footer/components/Footer/Сontacts/style.module.scss';
import Icon from 'components/Icon';
import {TContact} from 'modules/footer/components/Footer/types';

export const footerNavLinkList = [
    {
        code: 'vino',
        name: 'Вино',
        path: '/catalog/vino/',
    },
    {
        code: 'shampanskoe_i_igristoe_vino',
        name: 'Шампанское и игристое',
        path: '/catalog/shampanskoe_i_igristoe_vino/',
    },
    {
        code: 'viski',
        name: 'Виски',
        path: '/catalog/ksn/viski/',
    },
    {
        code: 'konyak',
        name: 'Коньяк',
        path: '/catalog/ksn/konyak/',
    },
    {
        code: 'ksn',
        name: 'Крепкие напитки',
        path: '/catalog/ksn/',
    },
    {
        code: 'voda_i_soki',
        name: 'Вода и соки',
        path: '/catalog/voda_i_soki/',
    },
];

export const MAIN_CONTACTS_CHEERS = {
    dataAutotestTarget: 'footer-menu-connection',
    dataAutotestTargetId: 'footer-menu-connection-email',
    href: 'mailto:cheers@simplewine.ru',
    itemClass: footerNavStyle.email,
    text: 'cheers@simplewine.ru',
    title: 'Есть винный вопрос? Пишите!',
};

export const MAIN_CONTACTS: TContact[] = [
    {
        href: 'tel:88007003797',
        text: '8 800 700 37 97',
        title: 'Звонок по России',
    },

    {
        href: 'tel:*6565',
        text: '*6565',
        title: '',
    },
];

export const MAIN_CITIES_IDS = [1, 2];
export const MOSCOW_CITY_ID = 1;

export const APP_LIST = (place: 'Footer' | 'menu' = 'Footer') => ({
    title: 'Скачать приложение Simplewine',
    linkList: [
        {
            icon: <Icon icon={`${place}-apple`} />,
            path: 'https://4004605.redirect.appmetrica.yandex.com/overview?appmetrica_tracking_id=676472398802855737&referrer=reattribution%3D1',
        },
        {
            icon: <Icon icon={`${place}-google-play`} />,
            path: 'https://4004605.redirect.appmetrica.yandex.com/overview?appmetrica_tracking_id=676472398802855737&referrer=reattribution%3D1',
        },
        {
            icon: <Icon icon={`${place}-rustore`} />,
            path: 'https://4004605.redirect.appmetrica.yandex.com/overview?appmetrica_tracking_id=534081816693391805&referrer=reattribution%3D1',
        },
        {
            icon: <Icon icon={`${place}-huawei`} />,
            path: 'https://4004605.redirect.appmetrica.yandex.com/overview?appmetrica_tracking_id=676472398802855737&referrer=reattribution%3D1',
        },
    ],
});

export const cartLinkList = [
    {
        icon: <Icon icon={'Telegram-xl'} />,
        path: '/',
    },
    // {
    //     icon: <Icon icon={'whats-app-xl'} />,
    //     path: '/',
    // },
    {
        icon: <Icon icon={'Footer-chat'} />,
        path: '/',
    },
];
